/**
 * Load carousel screenshots from assets/carousel/.
 * Supports `4.png` and `4_dashboard.png` — prefers the named file when both exist.
 */

const carouselImageContext = require.context(
  "../assets/carousel",
  false,
  /^\.\/\d+.*\.png$/
);

function parseCarouselKey(key) {
  const match = key.match(/^\.\/(\d+)(?:_(.+))?\.png$/i);
  if (!match) return null;
  return {
    number: Number.parseInt(match[1], 10),
    slug: match[2] || null,
    key,
  };
}

function humanizeSlug(slug) {
  return slug
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

const carouselByNumber = {};

carouselImageContext.keys().forEach((key) => {
  const parsed = parseCarouselKey(key);
  if (!parsed) return;

  const existing = carouselByNumber[parsed.number];
  const shouldReplace =
    !existing || (!existing.slug && parsed.slug);

  if (shouldReplace) {
    carouselByNumber[parsed.number] = {
      number: parsed.number,
      slug: parsed.slug,
      src: carouselImageContext(key),
    };
  }
});

/** @param {number} number */
export function getCarouselImage(number) {
  return carouselByNumber[number]?.src ?? null;
}

/**
 * @param {number} number
 * @param {string} [titleOverride]
 */
export function getCarouselSlide(number, titleOverride) {
  const entry = carouselByNumber[number];
  if (!entry) return null;

  const title =
    titleOverride || (entry.slug ? humanizeSlug(entry.slug) : "");

  return {
    src: entry.src,
    title,
    alt: title
      ? `CivixThread app — ${title}`
      : `CivixThread app screenshot ${number}`,
  };
}

/**
 * @param {number[]} order
 * @param {Record<number, string>} [titlesByNumber]
 */
export function getCarouselSlides(order, titlesByNumber = {}) {
  return order
    .map((number) => getCarouselSlide(number, titlesByNumber[number]))
    .filter(Boolean);
}

export function getLoadedCarouselNumbers() {
  return Object.keys(carouselByNumber)
    .map((n) => Number.parseInt(n, 10))
    .sort((a, b) => a - b);
}
